export default function (instance) {
  return {
    add_faculty(payload) {
      return instance.post("administrator/add_faculty", payload);
    },
    update_faculty(payload) {
      return instance.post("administrator/update_faculty", payload);
    },
    delete_faculty(payload) {
      return instance.post("administrator/delete_faculty", payload);
    },
    add_direction(payload) {
      return instance.post("administrator/add_direction", payload);
    },
    update_direction(payload) {
      return instance.post("administrator/update_direction", payload);
    },
    delete_direction(payload) {
      return instance.post("administrator/delete_direction", payload);
    },
    add_spes(payload) {
      return instance.post("administrator/add_spes", payload);
    },
    update_spes(payload) {
      return instance.post("administrator/update_spes", payload);
    },
    delete_spes(payload) {
      return instance.post("administrator/delete_spes", payload);
    },
  };
}
